module.exports = __webpack_public_path__ + "img/wl_prod1_5.e396c1ff.jpg";